// extracted by mini-css-extract-plugin
export default {"app":"app_app__byxVR","content":"app_content__4Vy7c"};